<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Online Order Receiving Employee</div>
		<div class="descriptionText">The POS-level employee responsible for processing incoming orders.</div>
		<div>
			<p-dropdown
				[options]="venueSvc.employeeList.value"
				optionLabel="nickName"
				optionValue="id"
				name="employeeList"
				[(ngModel)]="venueSvc.ooMenuConfig.employeeRecNum"
				filter="true"
				filterBy="nickName,firstName,lastName"
				[virtualScroll]="true"
				[virtualScrollItemSize]="31"
				[style]="{ width: '100%' }"
				(onChange)="changesToSaveChange.emit(true); changesToOoMenuConfigChange.emit(true)"
				appendTo="body"
			></p-dropdown>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Comments Menu Item</div>
		<div class="descriptionText">Comments & special instructions from guests will use this menu item</div>
		<div class="mb-3">
			<p-dropdown
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="commentMenuItem"
				[(ngModel)]="venueSvc.ooMenuConfig.commentsMenuId"
				filter="true"
				filterBy="name,displayName"
				[virtualScroll]="true"
				[virtualScrollItemSize]="31"
				[style]="{ width: '100%' }"
				(onChange)="changesToSaveChange.emit(true); changesToOoMenuConfigChange.emit(true)"
				appendTo="body"
			></p-dropdown>
		</div>
		<div>Exception Menu Item</div>
		<div class="descriptionText">Order Exceptions and important notes will use this menu item</div>
		<div class="mb-3">
			<p-dropdown
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="exceptionMenuItem"
				[(ngModel)]="venueSvc.ooMenuConfig.exceptionMenuId"
				filter="true"
				filterBy="name,displayName"
				[virtualScroll]="true"
				[virtualScrollItemSize]="31"
				(onChange)="changesToSaveChange.emit(true); changesToOoMenuConfigChange.emit(true)"
				[style]="{ width: '100%' }"
				appendTo="body"
			>
			</p-dropdown>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column"></div>
</div>
